import { CardPlaceholder } from '@components';
import { CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { Show } from 'solid-js';
import { orderStore } from '@store/orders';

export const CarrierLoadingCards = () => {
  return (
    <>
      <CollapsibleCard startTitle="Load" class="mb-2">
        <Show when={!orderStore.loading} fallback={<CardPlaceholder />}>
          ''
        </Show>
      </CollapsibleCard>
      <CollapsibleCard startTitle="Carrier Billing Info" class="mb-2">
        <Show when={!orderStore.loading} fallback={<CardPlaceholder />}>
          ''
        </Show>
      </CollapsibleCard>
      <CollapsibleCard startTitle="Stops" class="mb-2">
        <Show when={!orderStore.loading} fallback={<CardPlaceholder />}>
          ''
        </Show>
      </CollapsibleCard>
      <CollapsibleCard startTitle="Tracking" class="mb-2">
        <Show when={!orderStore.loading} fallback={<CardPlaceholder />}>
          ''
        </Show>
      </CollapsibleCard>
    </>
  );
};
